import * as React from 'react'
import Milliseconds from '../../helper/milliseconds'

interface Props {
    message?: {
        args: {
            cct: number
            cwt: number
        }
    }
}

export default class Compile extends React.PureComponent<Props> {
    render = () => {
        const { message } = this.props

        let intro = <p>We observed Traces showing a significant compile overhead while parsing files with require/include.</p>
        if (message) {
            const { args } = message
            intro = (
                <p>
                    This trace shows a compile overhead of <Milliseconds value={args.cwt} />{' '}
                    {args.cct === 0 ? null : <span> while parsing {args.cct} files with require/include</span>}.
                </p>
            )
        }
        return (
            <div>
                {intro}
                <p>PHP processes requests in two steps:</p>

                <ol>
                    <li>First it compiles every script that is executed directly or via require/include into opcodes.</li>
                    <li>Then these opcodes are executed and the result is generated.</li>
                </ol>

                <p>
                    The Opcache extension can <i>cache the first step</i> and will improve script execution significantly. It is included in
                    PHP by default and may be disabled.
                </p>

                <p>You can check if Opcache is installed by either:</p>

                <ul>
                    <li>
                        Calling <code>$ php -m</code> on the commandline to check for the <code>opcache</code> module.
                    </li>
                    <li>
                        Looking at the output for <code>phpinfo();</code>
                    </li>
                </ul>

                <p>
                    If you already have Opcache installed and still experience high compile times, you should check our blog post on{' '}
                    <a href="https://tideways.io/profiler/blog/fine-tune-your-opcache-configuration-to-avoid-caching-suprises">
                        Fine Tuning Opcache Configuration
                    </a>
                    .
                </p>
            </div>
        )
    }
}
